module.exports = __webpack_public_path__ + "img/welcome-background.e074b904.jpg";